import { render, staticRenderFns } from "./OSite.vue?vue&type=template&id=b3bad954&scoped=true"
import script from "./OSite.vue?vue&type=script&lang=js"
export * from "./OSite.vue?vue&type=script&lang=js"
import style0 from "./OSite.vue?vue&type=style&index=0&id=b3bad954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3bad954",
  null
  
)

export default component.exports